export default __webpack_public_path__ + "677147b93069ef817875056299b1199b.png";